import useEmblaCarousel from 'embla-carousel-react';

import { Image, Text } from '@ui/atoms';
import { Button } from '@ui/atoms/design-system';
import {
    NextButton,
    PrevButton,
} from '@components/Products/FixedDeposits/components/Carousel/CarouselButtons';
import {
    fdRedirectTo,
    getFdCarouselContent,
} from '@components/Products/FixedDeposits/utils/utils';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { triggerCustomEvent } from '@helpers/miscelleanous';
import { fdProductEvents } from '@helpers/enums/gaEventNameEnum';

const FDCarousels = ({ fixedDepositBanks, toggleModal }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        align: 'start',
        draggable: true,
    });

    const { width } = useWindowDimensions();
    const isMobile = width < 768;

    const handleOnClick = () => {
        triggerCustomEvent(fdProductEvents.CLICKED_FD_PRODUCT_BOOK_NOW);

        isMobile ? fdRedirectTo() : toggleModal();
    };

    const carouselContent = getFdCarouselContent(fixedDepositBanks);

    const scrollPrev = () => emblaApi && emblaApi.scrollPrev();
    const scrollNext = () => emblaApi && emblaApi.scrollNext();

    return (
        <div className="relative w-full px-4 md:px-12 lg:px-10 max-w-[1080px] md:mx-auto">
            <div className="relative">
                <div
                    className="pb-4 overflow-hidden pt-14 md:pt-18"
                    ref={emblaRef}
                    aria-label="Fixed Deposit Carousel"
                >
                    <div className="flex items-center">
                        {carouselContent.map((card) => (
                            <div
                                key={card.id}
                                className="flex-[0_0_85%] md:flex-[0_0_33%] lg:flex-[0_0_25%] px-2 min-w-0"
                            >
                                <div
                                    className="relative flex flex-col items-center justify-center px-3 pt-12 pb-3 border border-gray-100 shadow-md select-none rounded-xl"
                                    style={{ background: card.bg }}
                                >
                                    <div className='absolute p-1 border border-gray-200 bg-basicWhite -top-8 md:-top-8 rounded-full shadow-fd-card-image w-16 h-16'>
                                            <Image src={card?.icon || '/images/fd-card-logo-placeholder.svg'} className='w-full h-full' alt='fd-card-image' />
                                        </div>

                                    <div className="flex flex-col w-full gap-4 text-center">
                                        <div className="flex flex-col justify-between h-[126px]">
                                            <Text
                                                content={card.title}
                                                className="text-gray-700 p2-medium line-clamp-2"
                                            />
                                            <div className="flex flex-col gap-2">
                                                {card.details.map(
                                                    (
                                                        { label, value },
                                                        index
                                                    ) => (
                                                        <div
                                                            key={index}
                                                            className="flex items-center justify-between text-gray-500"
                                                        >
                                                            <Text
                                                                content={label}
                                                                className="p5-regular"
                                                            />
                                                            <Text
                                                                content={value}
                                                                className="text-gray-900 h4-semibold"
                                                                isInnerHtml
                                                            />
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                        <Button
                                            className="w-full py-2 border border-gray-300 rounded-md"
                                            onClick={handleOnClick}
                                            buttonText="Book FD"
                                            buttonType="outline"
                                            widthClass={'w-full'}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <PrevButton
                    className="hidden md:inline-block"
                    onClick={scrollPrev}
                />
                <NextButton
                    className="hidden md:inline-block"
                    onClick={scrollNext}
                />
            </div>
            <div className="flex items-center justify-center gap-3 mt-7 md:hidden">
                <PrevButton
                    className="inline-block md:hidden"
                    onClick={scrollPrev}
                    isMobile
                />
                <NextButton
                    className="inline-block md:hidden"
                    onClick={scrollNext}
                    isMobile
                />
            </div>
        </div>
    );
};

// const PrevButton = ({ className, isMobile = false, onClick, disabled }) => (
//     <Button
//         buttonType="outline"
//         className={cn(
//             'h-8 w-8 rounded-full p-0',
//             isMobile
//                 ? ''
//                 : 'absolute -left-12 top-[calc(50%+24px)] -translate-y-1/2 mx-auto text-center ',
//             className
//         )}
//         widthClass="w-8 h-8 !p-0"
//         disabled={disabled}
//         onClick={onClick}
//         buttonText={
//             <ArrowLeftIcon className="w-4 h-4 mx-auto text-center text-primary-500" />
//         }
//     />
// );

// const NextButton = ({ className, isMobile = false, onClick, disabled }) => (
//     <Button
//         buttonType="outline"
//         className={cn(
//             'h-8 w-8 rounded-full p-0',
//             isMobile
//                 ? ''
//                 : 'absolute -right-12 top-[calc(50%+24px)] -translate-y-1/2',
//             className
//         )}
//         widthClass="w-8 h-8 !p-0"
//         disabled={disabled}
//         onClick={onClick}
//         buttonText={
//             <ArrowRightIcon className="w-4 h-4 mx-auto text-center text-primary-500" />
//         }
//         aria-label="Next slide"
//     />
// );

export default FDCarousels;
